import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest.jsx";
import {
  FETCH_BUY_SELL_USER_ITEMS,
  FETCH_BUY_SELL_USER_ITEMS_DISTANCE_NEW
} from "../../constant/Apipath.jsx";
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { BIWhite } from "../../assets/helpers.jsx";
import { English } from "../../constant/EnglishFallback.jsx";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import RoomIcon from "@mui/icons-material/Room";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  MoreVert as MoreIcon,
  Search as SearchIcon,
  Close as CloseIcon
} from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../common/Loader.jsx";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import FilterOptions from "./FilterOptions";
import ItemDetailsModal from "./ItemDetailsModal";
import { setSelectlocation, setShowReport, setReportSuccess } from "../../redux/actions/actions.jsx";
import { useDispatch } from "react-redux";
import { getAddress } from "../../request/Fetchcurrentaddress.jsx";
import moment from "moment";
import "./BuySell.css";
import { useLocation, useNavigate } from "react-router-dom";
import Pageheader from "../common/Pageheader";
import Emptydata from "../common/Emptydata";

const BuySell = () => {
  const { loginData, selectLocation, reportSuccess, multiLanguageData } = useSelector((state) => state?.main);

  // Language data
  const LanguageData = multiLanguageData?.BuySell || {};
  const {
    TEXT_HEADER_BUY_SELL = English.BuySell.TEXT_HEADER_BUY_SELL,
    TEXT_HEADER_MY_LISTING_PAGE = English.BuySell.TEXT_HEADER_MY_LISTING_PAGE,
    TEXT_USING_CURRENT_LOCATION = English.BuySell.TEXT_USING_CURRENT_LOCATION,
    TEXT_SEARCH_PLACEHOLDER = English.BuySell.TEXT_SEARCH_PLACEHOLDER,
    TEXT_FILTER_BTN = English.BuySell.TEXT_FILTER_BTN,
    TEXT_MY_LISTINGS_BTN = English.BuySell.TEXT_MY_LISTINGS_BTN,
    TEXT_NO_LISTINGS_FOUND = English.BuySell.TEXT_NO_LISTINGS_FOUND,
    TEXT_CLEAR_ALL_FILTERS = English.BuySell.TEXT_CLEAR_ALL_FILTERS,
    TEXT_FOR_TRADE_BADGE = English.BuySell.TEXT_FOR_TRADE_BADGE,
    TEXT_NEARBY = English.BuySell.TEXT_NEARBY,
    TEXT_TRADE = English.BuySell.TEXT_TRADE,
    TEXT_RENTED_TAG = English.BuySell.TEXT_RENTED_TAG,
    TEXT_EXPIRY_PREFIX = English.BuySell.TEXT_EXPIRY_PREFIX,
    TEXT_KMS_AWAY = English.BuySell.TEXT_KMS_AWAY,
    TEXT_REPORT_LISTING = English.BuySell.TEXT_REPORT_LISTING
  } = LanguageData;
  let currentUserId = loginData?.userInformation?.UserId ?? 0;
  const debounceTimeout = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const [mainData, setMainData] = useState([]);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showItemDetailsModal, setShowItemDetailsModal] = useState(false);
  const [selectItemDetails, setSelectedItemDetails] = useState(null);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [locationButtonText, setLocationButtonText] = useState(TEXT_USING_CURRENT_LOCATION);
  const [pageNumber, setPageNumber] = useState(1);
  const [recordId, setRecordId] = useState(0);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [filterValues, setFilterValues] = useState({
    forSale: false,
    forTrade: false
  });
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const headerName = location.pathname === "/buy-sell" ? TEXT_HEADER_BUY_SELL : TEXT_HEADER_MY_LISTING_PAGE;
  const finalData = mainData;
  const navigate = useNavigate();
  useEffect(() => {
    if (selectLocation?.from === "buy-sell") {
      updateLocation();
    } else {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectLocation?.from === "buy-sell" && selectLocation?.open === false) {
      updateLocation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectLocation]);

  useEffect(() => {
    if (reportSuccess) {
      setPageNumber(1);
      getData(searchTerm, 1);
      dispatch(setReportSuccess(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportSuccess]);

  const updateLocation = async () => {
    const getLocation = await getAddress({
      lat: selectLocation.lat,
      lng: selectLocation.lng
    });
    // console.log("getLocation", getLocation);
    setLocationButtonText(getLocation?.objAddress?.postalCode);
    await getData("", 1, {
      lat: selectLocation?.lat,
      lng: selectLocation?.lng
    });
  };

  const loadData = async () => {
    try {
      const currentLocationValuesAtFirstTime = await getCurrentLocation();
      await getData("", 1, currentLocationValuesAtFirstTime);
    } catch (error) {
      console.error("loadData-> Error getting current location:", error);
    } finally {
      setIsLoading(false); // Ensure loading state is set to false in all cases
    }
  };

  const showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        alert(
          "You denied location access. Please enable location permissions for this site in your browser settings."
        );
        break;
      case error.POSITION_UNAVAILABLE:
        alert("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        alert("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        alert("An unknown error occurred.");
        break;
      default:
        break;
    }
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            resolve({ lat, lng });
          },
          (error) => {
            showError(error);
            reject(error);
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  };

  const getData = async (
    value,
    pageNumber,
    currentLocationValuesAtFirstTime,
    customFilters
  ) => {
    try {
      // Set loading state based on page number
      if (pageNumber === 1) {
        setIsLoading(true);
        setHasMore(true);
      }
      setAllDataLoaded(true);
      // Prepare the location object using the second function's variables
      const locationObj = {
        UserId: Number(currentUserId),
        UserLatitude:
          selectLocation?.from === "buy-sell"
            ? selectLocation?.lat
            : currentLocationValuesAtFirstTime?.lat,
        UserLongitude:
          selectLocation?.from === "buy-sell"
            ? selectLocation?.lng
            : currentLocationValuesAtFirstTime?.lng,
        PageNumber: pageNumber,
        NrRowsPerPage: 40,
        FullSearch: value?.trim() || ""
      };

      // Add filter conditions if they exist
      const activeFilters = customFilters || filterValues;
      if (activeFilters?.forSale && !activeFilters?.forTrade) {
        locationObj["ForTrade"] = false;
      }
      if (!activeFilters?.forSale && activeFilters?.forTrade) {
        locationObj["ForTrade"] = true;
      }

      // Fetch distances using the second function's API call
      const fetchItemDistanceRes = await Postrequestcall(
        FETCH_BUY_SELL_USER_ITEMS_DISTANCE_NEW,
        locationObj,
        loginData?.accessToken
      );
      const fetchItemDistanceResData = fetchItemDistanceRes?.data?.data ?? [];

      // Prepare the search parameters using second function's structure
      let searchArrayList = [value?.trim() ? { title: value } : {}];

      const fetchObj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 40,
        FullSearch: "",
        UserId: Number(currentUserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: searchArrayList,
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };

      // Add filter conditions if they exist
      if (activeFilters?.forSale && !activeFilters?.forTrade) {
        fetchObj["ForTrade"] = false;
      }
      if (!activeFilters?.forSale && activeFilters?.forTrade) {
        fetchObj["ForTrade"] = true;
      }

      // Fetch items using the second function's API call
      const fetchItemRes = await Postrequestcall(
        FETCH_BUY_SELL_USER_ITEMS,
        fetchObj,
        loginData?.accessToken
      );
      const fetchItemResData = fetchItemRes?.data?.data ?? [];

      // Important: Use first function's approach for mapping distances and image data
      const newListingArray = [];
      fetchItemResData.forEach((item) => {
        const distanceItem = fetchItemDistanceResData.find((i) => i.id === item.id);
        if (distanceItem) {
          const fallbackPictures = distanceItem.pictureList || distanceItem.picturelist || [];
          const normalizedFallbackPictures = fallbackPictures.map((picture) => ({
            ...picture,
            name: picture.name || picture.fileUrl || picture.pictureUrl || picture.thumbFileUrl || ""
          }));
          const imageSourceList =
            item?.pictureList?.length > 0
              ? item.pictureList
              : normalizedFallbackPictures;
          const newItem = {
            ...item,
            distance: distanceItem.distance,
            pictureList: imageSourceList
          };
          newListingArray.push(newItem);
        }
      });

      // Filter out self-created listings (using first function's approach)
      const finalArray = newListingArray.filter((item) => item.createdBy !== currentUserId);

      // Sort by distance (using first function's approach)
      const sortedArray = finalArray.sort((a, b) => {
        let dateA = a.distance,
          dateB = b.distance;
        return dateA - dateB;
      });

      // Update state based on page number (using first function's approach with second function's state update)
      if (pageNumber > 1) {
        setMainData((prevData) => prevData.concat(sortedArray));
      } else {
        setMainData(sortedArray);
      }

      if (fetchItemResData.length < 40) {
        setHasMore(false);
      }
      setAllDataLoaded(false);
    } catch (error) {
      console.error("getData-> Error while getting buy sell data:", error?.message ?? error);
      setAllDataLoaded(false);
    } finally {
      setIsLoading(false); // Ensure loading state is set to false in all cases
      setAllDataLoaded(false);
    }
  };

  useEffect(() => { }, [mainData]);

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const handleViewReport = () => {
    let reportObj = {
      showReport: true,
      name: "Buy_and_Sell",
      AppScreenId: 384,
      recordId: recordId ?? 0
    };
    dispatch(setShowReport(reportObj));
    setMoreMenuAnchorEl(null);
  };

  const handleChooselocation = () => {
    let locationModal = {
      open: true,
      lat: 0,
      lng: 0,
      from: "buy-sell"
    };
    dispatch(setSelectlocation(locationModal));
  };

  const handleMoreMenuClose = (event) => {
    event.stopPropagation();
    setMoreMenuAnchorEl(null);
  };

  async function handleItemClick(event, args) {
    event.stopPropagation();
    setSelectedItemDetails(args);
    setShowItemDetailsModal(true);
  }

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 1.5 : 3 }}>
      <Pageheader headerName={headerName} />

      {isLoading ? (
        <Loader />
      ) : (
        <Box sx={{ mt: 2 }}>
          {/* Header Actions & Search Section */}
          <Box className="search-container">
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={2}
              alignItems={{ xs: "stretch", md: "center" }}
              justifyContent="space-between"
            >
              <Stack direction="row" spacing={1.5} flexGrow={1} maxWidth={{ md: "600px" }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder={TEXT_SEARCH_PLACEHOLDER}
                  size="small"
                  value={searchTerm}
                  onChange={async (event) => {
                    let inputValue = event.target.value;
                    const cleanedValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    setSearchTerm(cleanedValue);
                    if (debounceTimeout.current) {
                      clearTimeout(debounceTimeout.current);
                    }
                    debounceTimeout.current = setTimeout(() => {
                      setIsLoading(true);
                      getData(cleanedValue, 1);
                    }, 1000);
                  }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "text.secondary" }} />
                        </InputAdornment>
                      ),
                      endAdornment: searchTerm && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={async () => {
                              setPageNumber(1);
                              setSearchTerm("");
                              await getData("", 1);
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ),
                      sx: { borderRadius: "12px", bgcolor: "#f8fafc" }
                    }
                  }}
                />
                <Button
                  startIcon={<FilterListIcon />}
                  sx={{
                    bgcolor: "#eff6ff",
                    color: "#3b82f6",
                    "&:hover": { bgcolor: "#dbeafe" },
                    borderRadius: "12px",
                    textTransform: "none",
                    fontWeight: 600,
                    px: 2
                  }}
                  onClick={() => setShowFilterOptions(true)}
                >
                  {TEXT_FILTER_BTN}
                </Button>
              </Stack>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{
                  flexShrink: 0,
                  width: { xs: "100%", md: "auto" },
                  justifyContent: { xs: "space-between", md: "flex-end" }
                }}
              >
                <Button
                  startIcon={<RoomIcon />}
                  variant="text"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    color: "text.primary",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "transparent", color: "#3b82f6" }
                  }}
                  onClick={() => handleChooselocation()}
                >
                  {locationButtonText}
                </Button>
                <Button
                  variant="contained"
                  disableElevation
                  startIcon={<BusinessCenterIcon />}
                  onClick={() => navigate("my-listing")}
                  sx={{
                    borderRadius: "12px",
                    textTransform: "none",
                    px: 3,
                    bgcolor: "#3b82f6",
                    whiteSpace: "nowrap",
                    minWidth: "fit-content",
                    "&:hover": { bgcolor: "#2563eb" }
                  }}
                >
                  {TEXT_MY_LISTINGS_BTN}
                </Button>
              </Stack>
            </Stack>
          </Box>

          {/* Items Grid Section */}
          <Box className="scrollable-container" id="scrollablediv_prodcut">
            {finalData.length !== 0 ? (
              <InfiniteScroll
                dataLength={finalData?.length}
                next={async () => {
                  increaseOffset((pageNr) => {
                    getData(searchTerm, pageNr);
                  });
                }}
                hasMore={hasMore}
                loader={
                  !hasMore || !allDataLoaded ? null : (
                    <Box display="flex" justifyContent="center" p={4}>
                      <Loader />
                    </Box>
                  )
                }
                scrollableTarget="scrollablediv_prodcut"
              >
                <div className="items-grid">
                  {finalData?.map((item, index) => (
                    <Card
                      key={item.id || index}
                      className="buysell-card"
                      onClick={(event) => handleItemClick(event, item)}
                    >
                      <div className="card-image-wrapper">
                        <IconButton
                          className="more-btn"
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            setSelectedItemDetails(item);
                            setMoreMenuAnchorEl(event.currentTarget);
                            setRecordId(item.id);
                          }}
                        >
                          <MoreIcon fontSize="small" />
                        </IconButton>
                        {item.forTrade && (
                          <Chip
                            className="card-badge"
                            label={TEXT_FOR_TRADE_BADGE}
                            size="small"
                            sx={{
                              bgcolor: "#fef9c3",
                              color: "#854d0e",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              border: "1px solid #fef08a"
                            }}
                          />
                        )}
                        {item?.statusName === "For Rent" && (
                          <Chip
                            className="card-badge"
                            label={TEXT_RENTED_TAG}
                            size="small"
                            sx={{
                              bgcolor: "#ede9fe",
                              color: "#5b21b6",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              border: "1px solid #ddd6fe"
                            }}
                          />
                        )}
                        <img
                          src={
                            item?.pictureList?.length !== 0
                              ? item?.pictureList?.[0].name
                              : PlaceholderImg
                          }
                          alt={item?.title}
                          className="card-image"
                          loading="lazy"
                          decoding="async"
                          onError={(e) => { e.target.src = PlaceholderImg; }}
                        />
                      </div>

                      <div className="card-content">
                        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                          <Box flexGrow={1}>
                            <h3 className="card-title">{item?.title}</h3>
                            <div className="card-distance">
                              <RoomIcon sx={{ fontSize: "14px" }} />
                              <span>{item.distance ? `${item.distance?.toFixed(2)} ${TEXT_KMS_AWAY}` : TEXT_NEARBY}</span>
                            </div>
                          </Box>
                        </Stack>

                        <div style={{ marginTop: "auto", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                          <span className="card-price">
                            {item.forTrade ? TEXT_TRADE : `$${item?.price?.toLocaleString()}`}
                          </span>
                          {item?.expiryDate && item?.expiryDate !== "null" && (
                            <Typography variant="caption" sx={{ color: "#10b981", fontWeight: 600 }}>
                              {TEXT_EXPIRY_PREFIX} {moment(item.expiryDate).format("MMM DD")}
                            </Typography>
                          )}
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </InfiniteScroll>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 10,
                  bgcolor: "white",
                  borderRadius: "16px"
                }}
              >
                <Emptydata
                  icon={<BusinessCenterIcon sx={{ fontSize: 64, color: "#e2e8f0" }} />}
                  firstText={TEXT_NO_LISTINGS_FOUND}
                />
                <Button
                  variant="text"
                  onClick={() => {
                    setSearchTerm("");
                    const resetFilters = { forSale: false, forTrade: false };
                    setFilterValues(resetFilters);
                    getData("", 1, null, resetFilters);
                  }}
                  sx={{ mt: 2 }}
                >
                  {TEXT_CLEAR_ALL_FILTERS}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      )}

      {showFilterOptions && (
        <FilterOptions
          open={showFilterOptions}
          onClose={() => {
            setShowFilterOptions(false);
            getData(searchTerm, 1);
          }}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
        />
      )}

      {showItemDetailsModal && (
        <ItemDetailsModal
          open={showItemDetailsModal}
          onClose={() => {
            setSelectedItemDetails(null);
            setShowItemDetailsModal(false);
          }}
          item={selectItemDetails}
        />
      )}

      <Menu
        anchorEl={moreMenuAnchorEl}
        open={Boolean(moreMenuAnchorEl)}
        onClose={handleMoreMenuClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
            mt: 1
          }
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleViewReport();
            handleMoreMenuClose(event);
          }}
          sx={{ color: "#ef4444", fontWeight: 500 }}
        >
          {TEXT_REPORT_LISTING}
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default BuySell;
